import { LoomIcon as newLoomIcon } from '@atlaskit/temp-nav-app-icons/loom';

import { DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI } from '../../entities';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { getIconVersion } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { LoomIcon } from './icon';
import { LoomSearchResultIcon } from './search-result-icon';

export const loomConfig: ThirdPartyConfig = {
	displayName: 'Loom',
	id: 'loom',
	icon: getIconVersion(newLoomIcon, LoomIcon, 'Loom', 'small'),
	searchResultIcon: getIconVersion(newLoomIcon, LoomSearchResultIcon, 'Loom', 'large'),
	integrationAri: 'ari:cloud:platform::integration/loom',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Video,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Video],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
};
